export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.5 2A1.5 1.5 0 000 3.5V5h16V3.5A1.5 1.5 0 0014.5 2h-13zM16 7H0v5.5A1.5 1.5 0 001.5 14h13a1.5 1.5 0 001.5-1.5V7z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};